import React from "react";
import styled from "styled-components";
import { Colors } from "../ColorConstants";
import {
  AlmahaImage,
  AppStore,
  DownloadFooter,
  DownloadImage,
  GooglePlay,
  LandingBg,
  MobileScreen,
  Parks,
  QRCode,
} from "../assets/images";
import Section from "../component/card";

const DownloadPage = () => {
  const openBookOnlineLink = () => {
    const url = "https://almahaapp.almahaisland.com/booking/auth/home";
    window.open(url, "_blank");
  };
  return (
    <MainDiv>
      <StyledBanner />
      <SecondSubView>
        <WelcomeText>
          8 Entertainment Destinations.
          <br />
          Endless Fun.
        </WelcomeText>
        <WelcomeSubText>
          Introducing Al Maha mobile app - Elevate your Lifestyle and experience
          the best that Qatar has to offer!
        </WelcomeSubText>
        <SubHeader>
          <Header1>
            <InfoText>Quick Park Bookings</InfoText>
            <WelcomeSubText2>
              Don’t want to install the app yet! No worries,<br></br> go ahead
              and book on our beautiful web app!
            </WelcomeSubText2>
            <StoreImages>
              <BookNowButton onClick={openBookOnlineLink}>
                Book Online
              </BookNowButton>
            </StoreImages>
          </Header1>
          <Separator />
          <Header1>
            <InfoText>Download the Al Maha mobile app today!</InfoText>
            <WelcomeSubText2>
              Don’t miss out on the best experiences Qatar has to offer.
              <br></br>
              Download Al Maha now and elevate your lifestyle.
            </WelcomeSubText2>
            <StoreImages>
              <a href="https://play.google.com/store/apps/details?id=com.estithmarholding.almahaisland&hl=en_ZA&gl=US">
                <StoreImage src={GooglePlay} alt="Play Store" />
              </a>
              <a href="https://apps.apple.com/app/apple-store/id6443964600?pt=118552829&ct=Al%20Maha%20App%20Download&mt=8">
                <StoreImage src={AppStore} alt="App Store" />
              </a>
            </StoreImages>
          </Header1>
        </SubHeader>
        <StyledContainer>
          <Section
            heading="Entertainment Booking"
            subText="Plan and book tickets to Qatar's top entertainment parks and destinations."
          />
          <Section
            heading="Exclusive Deals"
            subText="Grab discounts and special offers only available to Al Maha users."
          />
          <Section
            heading="Fine Dining Reservations"
            subText="Reserve tables at our high-end restaurants and relish gastronomic experiences."
          />
        </StyledContainer>
        <ImageContainer>
          <Image src={Parks} alt="Parks" />
        </ImageContainer>
      </SecondSubView>
      <StyledFooter>
        <FooterContent>
          <FooterLeft>
            <FooterImage src={AlmahaImage} alt="Your Image Alt Text" />
            <FooterText>
              Copyright ©{" "}
              <FooterSubText>
                2023. All rights reserved by Al Maha.
              </FooterSubText>{" "}
              | - Powered by <FooterSubText>PIH</FooterSubText>
            </FooterText>
          </FooterLeft>
          <FooterQRCode src={QRCode} alt="QR Code" />
          <FooterAlmaha src={MobileScreen} alt="Mobile Screen" />
        </FooterContent>
      </StyledFooter>
    </MainDiv>
  );
};

const MainDiv = styled.div`
  background-image: url(${LandingBg});
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
`;

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${DownloadFooter});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
`;

const StyledBanner = styled.div`
  background-image: url(${DownloadImage});
  height: 25rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  padding: 4.5rem 0;
  box-sizing: border-box;
  @media (max-width: 700px) {
    height: 15rem;
  }
`;

const SecondSubView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: 1rem;
`;

const WelcomeText = styled.span`
  color: ${Colors.brickRed};
  text-align: center;
  font-family: Poppins;
  font-size: 2.5rem;
  font-weight: 700;
  padding: 1rem 1rem;
  @media (max-width: 700px) {
    font-size: 1.625rem;
  }
`;

const WelcomeSubText = styled(WelcomeText)`
  color: ${Colors.deepBlack};
  font-size: 1.5rem;
  font-weight: 600;
  @media (max-width: 700px) {
    font-size: 0.938rem;
  }
`;

const WelcomeSubText2 = styled(WelcomeSubText)`
  color: ${Colors.lightGrey};
  padding: 0rem 1rem;
  font-weight: 500;
  font-size: 1rem;
  display: flex;
  justify-content: center;
`;

const InfoText = styled.span`
  color: ${Colors.black};
  text-align: center;
  align-self: center;
  font-family: Poppins;
  font-size: 1.3rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  margin-top: 1rem;
  padding: 0.4rem 1.5rem;
  justify-content: center;
  @media (max-width: 700px) {
    font-size: 1.25rem;
    margin-top: 1rem;
  }
`;

const ImageContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 60%;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  margin: 1rem;
  @media (max-width: 700px) {
    flex-direction: column;
  }
  position: relative;
  z-index: 99;
`;

const FooterText = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-size: 0.7rem;
  text-align: center;
  color: ${Colors.davyGrey};
  @media (min-width: 700px) {
    flex-direction: row;
    margin-top: 2rem;
  }
`;

const FooterImage = styled.img`
  width: 70%;
`;

const StoreImages = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  @media (min-width: 700px) {
    flex-direction: row;
    margin-top: 2rem;
  }
`;

const StoreImage = styled.img`
  width: 200px;
  margin-left: 1rem;
  padding: 0rem 0rem;
  @media (max-width: 700px) {
    margin-bottom: 0.6rem;
  }
`;
const FooterSubText = styled(FooterText)`
  font-weight: 700;
  padding: 0;
  color: ${Colors.davyGrey};
`;
const FooterQRCode = styled.img`
  width: 60%;
  max-width: 8rem;
  padding: 1rem;
  @media (max-width: 700px) {
    max-width: 6rem;
  }
`;

const FooterAlmaha = styled.img`
  width: 50%;
  @media (max-width: 700px) {
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 60%;
    object-fit: cover;
    opacity: 0.4;
  }
`;
const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 700px) {
    z-index: 1;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 0rem 1rem;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

const SubHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

const Header1 = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
`;
const Separator = styled.div``;

const BookNowButton = styled.button`
  background-color: ${Colors.beachAlley};
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  gap: 0.25rem;
  font-size: 1.5rem;
  font-family: Poppins;
  font-weight: 600;
  align-self: center;
  display: flex;
  &:hover {
    opacity: 0.6;
  }
`;

export default DownloadPage;
